import React from 'react';
import { useTranslation } from 'react-i18next';
import { Building2, Users, TrendingUp } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { formatCurrencyCompact } from '../../lib/currency';
import { usePayrollUIConfig } from '../../hooks/usePayrollUIConfig';

const OrganigrammeStatsCards = ({ stats }) => {
  const { t } = useTranslation();
  const { config } = usePayrollUIConfig();
  const currency = config?.currency || 'TND';
  return (
  <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <Building2 className="h-4 w-4 text-blue-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t("organigramme.departments")}</p>
            <p className="text-2xl font-bold">{stats.total_departments}</p>
            {stats.department_with_staff !== undefined && (
              <p className="text-xs text-muted-foreground">{t("organigramme.withStaff", { count: stats.department_with_staff })}</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>

    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <Users className="h-4 w-4 text-green-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t("organigramme.totalEmployees")}</p>
            <p className="text-2xl font-bold text-green-600">{stats.total_employees}</p>
            {stats.nb_responsables !== undefined && (
              <p className="text-xs text-muted-foreground">{t("organigramme.managersCount", { count: stats.nb_responsables })}</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>

    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <TrendingUp className="h-4 w-4 text-purple-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t("organigramme.maxLevels")}</p>
            <p className="text-2xl font-bold text-purple-600">{stats.niveaux_max}</p>
            {stats.taux_responsabilite !== undefined && (
              <p className="text-xs text-muted-foreground">{t("organigramme.pctWithManager", { pct: stats.taux_responsabilite })}</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>

    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <span className="text-orange-600 font-bold">{currency}</span>
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t("organigramme.totalBudget")}</p>
            <p className="text-2xl font-bold text-orange-600">{formatCurrencyCompact(stats.budget_total, currency)}</p>
            {stats.taux_occupation !== undefined && (
              <p className="text-xs text-muted-foreground">{t("organigramme.pctOccupation", { pct: stats.taux_occupation })}</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
  );
};

export default OrganigrammeStatsCards;
